import { useEffect, useState } from "react";
import { StorageService } from "../services/StorageService";
import { Constants } from "../Constants";

export const useWelcomeState = () => {
  const [showWelcome, setShowWelcome] = useState(false);
  const storageService = new StorageService();

  useEffect(() => {
    const isFirstSignIn =
      storageService.get(Constants.storage.keys.firstSignIn) !== "false";
    setShowWelcome(isFirstSignIn);
  }, []);

  const handleShowWelcome = () => {
    setShowWelcome(true);
  };

  const handleCompleteWelcome = () => {
    storageService.set(
      Constants.storage.keys.firstSignIn,
      JSON.stringify(false)
    );
    setShowWelcome(false);
  };

  return {
    showWelcome,
    setShowWelcome,
    handleShowWelcome,
    handleCompleteWelcome,
  };
};
